import type { ComponentType } from 'react';
import BuyingHouse from 'assets/images/quick-calculator/buying-house.svg?react';
import BuyingApartment from 'assets/images/quick-calculator/buying-apartment.svg?react';
import BuildingHouse from 'assets/images/quick-calculator/building-house.svg?react';
import RenovationHouse from 'assets/images/quick-calculator/renovation-house.svg?react';
import LifestyleCalculator from 'assets/images/quick-calculator/lifestyle-calculator.svg?react';
import {
  BUYING_HOUSE,
  NEW_APARTMENT,
  NEW_BUILDING,
  RENOVATION_HOUSE,
  LIFESTYLE_CALCULATOR,
} from 'constants/constants';

export interface IQuickCalculatorProject {
  label: string;
  type: string;
  img: ComponentType<{ title?: string }>;
  altText?: string;
  xlSize?: number;
}

export const projects: IQuickCalculatorProject[] = [
  {
    label: 'project_wizard.renovation_house',
    type: RENOVATION_HOUSE,
    img: RenovationHouse,
    altText: 'alt_text.quick_calculator.renovation_house',
  },
  {
    label: 'project_wizard.buying_house',
    type: BUYING_HOUSE,
    img: BuyingHouse,
    altText: 'alt_text.quick_calculator.buying_house',
  },
  {
    label: 'project_wizard.new_building',
    type: NEW_BUILDING,
    img: BuildingHouse,
    altText: 'alt_text.quick_calculator.new_building',
  },
  {
    label: 'project_wizard.new_apartment',
    type: NEW_APARTMENT,
    img: BuyingApartment,
    altText: 'alt_text.quick_calculator.new_apartment',
  },
];

export const tools: IQuickCalculatorProject[] = [
  {
    label: 'project_types.lifestyle_calculator',
    type: LIFESTYLE_CALCULATOR,
    img: LifestyleCalculator,
    altText: 'alt_text.quick_calculator.lifestyle_calculator',
  },
];
